import React from "react";

export function ModalShell({ title, subtitle, children, onClose, wide }) {
  return (
    <div className="fixed inset-0 bg-black/35 flex items-center justify-center p-6 z-50">
      <div className={`bg-card border border-border rounded-2xl w-full ${wide ? "max-w-2xl" : "max-w-md"} max-h-[90vh] flex flex-col`}>
        <div className="px-6 pt-6 pb-4 border-b border-border">
          <h2 className="text-base font-semibold text-foreground">{title}</h2>
          {subtitle && <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>}
        </div>
        <div className="px-6 py-4 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}

export function Field({ label, hint, children }) {
  return (
    <div className="mb-3">
      <label className="block text-xs font-medium text-muted-foreground mb-1">{label}</label>
      {children}
      {hint && <p className="text-[11px] text-muted-foreground mt-1">{hint}</p>}
    </div>
  );
}

export function TextInput(props) {
  return (
    <input
      {...props}
      className="w-full border border-input rounded-lg px-3 py-2 text-sm bg-background text-foreground"
    />
  );
}

export function SelectInput({ children, ...props }) {
  return (
    <select
      {...props}
      className="w-full border border-input rounded-lg px-3 py-2 text-sm bg-background text-foreground"
    >
      {children}
    </select>
  );
}

export function ModalFooter({ onClose, onSave, saving, saveLabel = "Save", secondary }) {
  return (
    <div className="flex justify-end gap-2 mt-4 px-6 pb-6 pt-2 border-t border-border -mx-6 -mb-6">
      <button onClick={onClose} className="text-sm text-muted-foreground px-3 py-2">
        Cancel
      </button>
      {secondary}
      <button
        onClick={onSave}
        disabled={saving}
        className="bg-primary text-primary-foreground rounded-lg px-4 py-2 text-sm font-semibold disabled:opacity-60"
      >
        {saving ? "Saving..." : saveLabel}
      </button>
    </div>
  );
}

export function ErrorBanner({ error }) {
  if (!error) return null;
  return (
    <p className="text-sm text-destructive bg-destructive/10 rounded-md px-3 py-2 mb-3">{error}</p>
  );
}
